import React from 'react';

const Sponsors = ({ sponsors }) => {
  if (!sponsors || sponsors.length === 0) {
    return null;
  }

  const sponsorsSectionStyle = {
    width: '100%',
    maxWidth: '1500px',
    margin: '20px auto',
    padding: '20px 4%',
  };

  const sponsorsGridStyle = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
    gap: '12px',
    alignItems: 'center',
    justifyItems: 'center'
  };

  const sponsorItemStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '8px',
    borderRadius: '8px',
    transition: 'all 0.3s ease',
    minHeight: '80px'
  };

  const sponsorLogoStyle = {
    maxWidth: '100%',
    maxHeight: '60px',
    objectFit: 'contain',
    filter: 'grayscale(20%)',
    transition: 'filter 0.3s ease'
  };

  return (
    <div style={sponsorsSectionStyle}>
      <div style={sponsorsGridStyle}>
        {sponsors.map((sponsor) => (
          <div 
            key={sponsor.id} 
            style={sponsorItemStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <img 
              src={sponsor.url} 
              alt={sponsor.nombre}
              title={sponsor.nombre}
              style={sponsorLogoStyle}
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Sponsors;